// Mock data for Globaltreats cake shop (frontend-only phase)

export const CATEGORIES = [
  { slug: "all", name: "All Cakes", image: "https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=400&q=80" },
  { slug: "birthday", name: "Birthday Cakes", image: "https://images.unsplash.com/photo-1606983340126-99ab4feaa64a?w=400&q=80" },
  { slug: "anniversary", name: "Anniversary Cakes", image: "https://images.unsplash.com/photo-1733515371242-2c7f8255fde6?w=400&q=80" },
  { slug: "kids", name: "Kids Cakes", image: "https://images.unsplash.com/photo-1552689486-ce080445fbb6?w=400&q=80" },
  { slug: "designer", name: "Designer Cakes", image: "https://images.unsplash.com/photo-1588195538326-c5b1e9f80a1b?w=400&q=80" },
  { slug: "vintage", name: "Vintage Cakes", image: "https://images.unsplash.com/photo-1574538860416-baadc5d4ec57?w=400&q=80" },
  { slug: "wedding", name: "Wedding Cakes", image: "https://images.unsplash.com/photo-1678473289821-1818e3f82e9a?w=400&q=80" },
  { slug: "chocolate", name: "Chocolate Cakes", image: "https://images.pexels.com/photos/18613262/pexels-photo-18613262.jpeg?auto=compress&cs=tinysrgb&w=400" },
  { slug: "cupcakes", name: "Cup Cakes", image: "/assets/cupcake-vanilla-strawberry.png" },
  { slug: "plum-cakes", name: "Plum Cakes", image: "/assets/plum-cake-dry-fruit.png" },
  { slug: "gen-z", name: "Gen Z Cakes", image: "https://images.unsplash.com/photo-1741969494234-7d4bcd1002ab?w=400&q=80" },
];

export const FLAVORS = ["Chocolate Truffle", "Vanilla", "Red Velvet", "Butterscotch", "Black Forest", "Pineapple"];
export const WEIGHTS = ["0.5 Kg", "1 Kg", "1.5 Kg", "2 Kg", "3 Kg"];

export const PRODUCTS = [
  {
    id: "GT4507", name: "Heart Shape Ribbon Cake", slug: "heart-shape-ribbon-cake",
    image: "https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=800&q=80", "https://images.unsplash.com/photo-1568827999250-3f6afff96e66?w=800&q=80"],
    categories: ["anniversary", "designer"], flavor: "Chocolate Truffle", weight: "1 Kg",
    price: 1799, mrp: 1999, rating: 4.8, reviews: 28, delivery: "Today", bestseller: true,
    description: "A dreamy heart-shaped cake wrapped in a delicate buttercream ribbon. Perfect for anniversaries and romantic surprises.",
  },
  {
    id: "GT4500", name: "Gen Z Meme Theme Cake", slug: "gen-z-meme-theme-cake",
    image: "https://images.unsplash.com/photo-1741969494234-7d4bcd1002ab?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1741969494234-7d4bcd1002ab?w=800&q=80"],
    categories: ["gen-z", "birthday"], flavor: "Chocolate Truffle", weight: "0.5 Kg",
    price: 899, mrp: 999, rating: 4.6, reviews: 20, delivery: "Today", bestseller: true,
    description: "A quirky, colourful meme-inspired cake that speaks fluent internet. The ultimate gift for your Gen Z bestie.",
  },
  {
    id: "GT4434", name: "White Vintage Cake", slug: "white-vintage-cake",
    image: "https://images.unsplash.com/photo-1574538860416-baadc5d4ec57?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1574538860416-baadc5d4ec57?w=800&q=80"],
    categories: ["vintage", "designer"], flavor: "Vanilla", weight: "1 Kg",
    price: 1799, mrp: 1899, rating: 4.7, reviews: 10, delivery: "Today", bestseller: false,
    description: "Timeless white vintage cake with hand-piped lambeth detailing and a soft pastel palette.",
  },
  {
    id: "GT4431", name: "Sunny Rainbow 1st Birthday Cake", slug: "sunny-rainbow-1st-birthday-cake",
    image: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80"],
    categories: ["kids", "birthday"], flavor: "Vanilla", weight: "3 Kg",
    price: 4299, mrp: 4599, rating: 4.9, reviews: 4, delivery: "Today", bestseller: false,
    description: "A joyful multi-layer rainbow cake to make the very first birthday unforgettable.",
  },
  {
    id: "GT4423", name: "Cocomelon Photo Cake", slug: "cocomelon-photo-cake",
    image: "https://images.unsplash.com/photo-1552689486-ce080445fbb6?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1552689486-ce080445fbb6?w=800&q=80"],
    categories: ["kids"], flavor: "Butterscotch", weight: "0.5 Kg",
    price: 849, mrp: 949, rating: 4.5, reviews: 2, delivery: "Today", bestseller: false,
    description: "Bright, playful photo cake themed for little ones who love sing-along adventures.",
  },
  {
    id: "GT4417", name: "Basket and Sneakers Cake", slug: "basket-and-sneakers-cake",
    image: "https://images.pexels.com/photos/10336820/pexels-photo-10336820.jpeg?auto=compress&cs=tinysrgb&w=600",
    gallery: ["https://images.pexels.com/photos/10336820/pexels-photo-10336820.jpeg?auto=compress&cs=tinysrgb&w=800"],
    categories: ["designer", "gen-z"], flavor: "Chocolate Truffle", weight: "1 Kg",
    price: 1599, mrp: 1799, rating: 4.6, reviews: 3, delivery: "Today", bestseller: false,
    description: "A sculpted cake for the sneakerhead and hoops fan in your life. Fully edible fondant art.",
  },
  {
    id: "GT4439", name: "Frozen Princess Photo Cake", slug: "frozen-princess-photo-cake",
    image: "https://images.unsplash.com/photo-1577998474517-7eeeed4e448a?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1577998474517-7eeeed4e448a?w=800&q=80"],
    categories: ["kids", "birthday"], flavor: "Vanilla", weight: "0.5 Kg",
    price: 849, mrp: 999, rating: 4.7, reviews: 4, delivery: "Today", bestseller: true,
    description: "An icy-blue princess themed photo cake that sparkles like a winter wonderland.",
  },
  {
    id: "GT4412", name: "Jungle Paradise Cake", slug: "jungle-paradise-cake",
    image: "https://images.unsplash.com/photo-1759922550477-19632d9ce30b?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1759922550477-19632d9ce30b?w=800&q=80"],
    categories: ["kids", "designer"], flavor: "Chocolate Truffle", weight: "1 Kg",
    price: 1599, mrp: 1699, rating: 4.8, reviews: 5, delivery: "Today", bestseller: false,
    description: "A wild jungle safari cake bursting with edible animals and lush green detailing.",
  },
  {
    id: "GT4527", name: "Elegant Wedding Cake", slug: "elegant-wedding-cake",
    image: "https://images.unsplash.com/photo-1678473289821-1818e3f82e9a?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1678473289821-1818e3f82e9a?w=800&q=80"],
    categories: ["wedding", "designer"], flavor: "Red Velvet", weight: "3 Kg",
    price: 8999, mrp: 9999, rating: 5.0, reviews: 12, delivery: "Tomorrow", bestseller: true,
    description: "A grand multi-tier wedding cake adorned with sugar florals for your most special day.",
  },
  {
    id: "GT4523", name: "Victorian Vintage Cake", slug: "victorian-vintage-cake",
    image: "https://images.unsplash.com/photo-1525257831700-183b9b8bf5c4?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1525257831700-183b9b8bf5c4?w=800&q=80"],
    categories: ["vintage"], flavor: "Butterscotch", weight: "1.5 Kg",
    price: 2399, mrp: 2599, rating: 4.7, reviews: 1, delivery: "Today", bestseller: false,
    description: "Old-world charm meets modern taste with intricate Victorian piping and pearls.",
  },
  {
    id: "GT4517", name: "Baby Shower Teddy Cake", slug: "baby-shower-teddy-cake",
    image: "https://images.unsplash.com/photo-1568827999250-3f6afff96e66?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1568827999250-3f6afff96e66?w=800&q=80"],
    categories: ["kids", "designer"], flavor: "Vanilla", weight: "1 Kg",
    price: 1699, mrp: 1899, rating: 4.8, reviews: 3, delivery: "Today", bestseller: false,
    description: "The cutest teddy-topped cake to welcome the newest member of the family.",
  },
  {
    id: "GT4512", name: "Heart Anniversary Cake", slug: "heart-anniversary-cake",
    image: "https://images.unsplash.com/photo-1733515371242-2c7f8255fde6?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1733515371242-2c7f8255fde6?w=800&q=80"],
    categories: ["anniversary"], flavor: "Red Velvet", weight: "1 Kg",
    price: 1799, mrp: 1999, rating: 4.9, reviews: 16, delivery: "Today", bestseller: true,
    description: "A luscious red velvet heart cake to celebrate years of togetherness.",
  },
  {
    id: "GT4511", name: "Heart Theme Vintage Cake", slug: "heart-theme-vintage-cake",
    image: "https://images.unsplash.com/photo-1604702433171-33756f3f3825?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1604702433171-33756f3f3825?w=800&q=80"],
    categories: ["vintage", "anniversary"], flavor: "Vanilla", weight: "1 Kg",
    price: 1799, mrp: 1899, rating: 4.6, reviews: 7, delivery: "Today", bestseller: false,
    description: "Pastel vintage cake with a romantic heart motif and dainty piped roses.",
  },
  {
    id: "GT4510", name: "White Vintage Ribbon Cake", slug: "white-vintage-ribbon-cake",
    image: "https://images.pexels.com/photos/12742498/pexels-photo-12742498.jpeg?auto=compress&cs=tinysrgb&w=600",
    gallery: ["https://images.pexels.com/photos/12742498/pexels-photo-12742498.jpeg?auto=compress&cs=tinysrgb&w=800"],
    categories: ["vintage", "wedding"], flavor: "Vanilla", weight: "1 Kg",
    price: 1699, mrp: 1799, rating: 4.7, reviews: 8, delivery: "Today", bestseller: false,
    description: "Clean white vintage cake finished with a graceful buttercream ribbon bow.",
  },
  {
    id: "GT4509", name: "Pink Vintage Anniversary Cake", slug: "pink-vintage-anniversary-cake",
    image: "https://images.pexels.com/photos/31243081/pexels-photo-31243081.jpeg?auto=compress&cs=tinysrgb&w=600",
    gallery: ["https://images.pexels.com/photos/31243081/pexels-photo-31243081.jpeg?auto=compress&cs=tinysrgb&w=800"],
    categories: ["vintage", "anniversary"], flavor: "Butterscotch", weight: "1 Kg",
    price: 1699, mrp: 1899, rating: 4.9, reviews: 14, delivery: "Today", bestseller: true,
    description: "Blush-pink vintage cake with lambeth piping — soft, elegant and utterly charming.",
  },
  {
    id: "GT4508", name: "Vintage Theme Anniversary Cake", slug: "vintage-theme-anniversary-cake",
    image: "https://images.unsplash.com/photo-1627935817583-a8d4531ccc62?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1627935817583-a8d4531ccc62?w=800&q=80"],
    categories: ["vintage", "anniversary"], flavor: "Red Velvet", weight: "1 Kg",
    price: 1699, mrp: 1799, rating: 4.7, reviews: 11, delivery: "Today", bestseller: false,
    description: "A refined vintage anniversary cake with delicate detailing and premium red velvet sponge.",
  },
  {
    id: "GT4506", name: "Chocolate Berry Truffle Cake", slug: "chocolate-berry-truffle-cake",
    image: "https://images.pexels.com/photos/18613262/pexels-photo-18613262.jpeg?auto=compress&cs=tinysrgb&w=600",
    gallery: ["https://images.pexels.com/photos/18613262/pexels-photo-18613262.jpeg?auto=compress&cs=tinysrgb&w=800"],
    categories: ["chocolate", "designer"], flavor: "Chocolate Truffle", weight: "1.5 Kg",
    price: 2599, mrp: 2799, rating: 4.9, reviews: 22, delivery: "Tomorrow", bestseller: true,
    description: "Decadent dark chocolate truffle cake crowned with fresh seasonal berries.",
  },
  {
    id: "GT4505", name: "Classic Chocolate Drip Cake", slug: "classic-chocolate-drip-cake",
    image: "https://images.unsplash.com/photo-1588195538326-c5b1e9f80a1b?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1588195538326-c5b1e9f80a1b?w=800&q=80"],
    categories: ["chocolate", "designer"], flavor: "Chocolate Truffle", weight: "1 Kg",
    price: 1699, mrp: 1899, rating: 4.8, reviews: 7, delivery: "Today", bestseller: false,
    description: "A crowd-favourite white cake with glossy chocolate drip and elegant finish.",
  },
  {
    id: "GT4490", name: "Happy Birthday Rose Cake", slug: "happy-birthday-rose-cake",
    image: "https://images.unsplash.com/photo-1606983340126-99ab4feaa64a?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1606983340126-99ab4feaa64a?w=800&q=80"],
    categories: ["birthday", "chocolate"], flavor: "Chocolate Truffle", weight: "1 Kg",
    price: 1299, mrp: 1499, rating: 4.7, reviews: 31, delivery: "Today", bestseller: true,
    description: "Rich chocolate cake with piped buttercream roses and a classic Happy Birthday topper.",
  },
  {
    id: "GT4480", name: "Strawberry Bliss Cake", slug: "strawberry-bliss-cake",
    image: "https://images.unsplash.com/photo-1568827999250-3f6afff96e66?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1568827999250-3f6afff96e66?w=800&q=80"],
    categories: ["birthday", "designer"], flavor: "Vanilla", weight: "1 Kg",
    price: 1399, mrp: 1599, rating: 4.6, reviews: 9, delivery: "Today", bestseller: false,
    description: "Fresh strawberry cream cake layered with juicy berries and light vanilla sponge.",
  },
  {
    id: "GT4470", name: "Superhero Theme Cake", slug: "superhero-theme-cake",
    image: "https://images.pexels.com/photos/10336820/pexels-photo-10336820.jpeg?auto=compress&cs=tinysrgb&w=600",
    gallery: ["https://images.pexels.com/photos/10336820/pexels-photo-10336820.jpeg?auto=compress&cs=tinysrgb&w=800"],
    categories: ["kids", "birthday"], flavor: "Butterscotch", weight: "2 Kg",
    price: 2499, mrp: 2799, rating: 4.8, reviews: 6, delivery: "Today", bestseller: false,
    description: "An action-packed superhero cake to make any young hero's birthday super special.",
  },
  {
    id: "GT4460", name: "Rainbow Sprinkle Cake", slug: "rainbow-sprinkle-cake",
    image: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80"],
    categories: ["kids", "gen-z"], flavor: "Vanilla", weight: "1 Kg",
    price: 1499, mrp: 1699, rating: 4.7, reviews: 13, delivery: "Today", bestseller: false,
    description: "A vibrant rainbow layer cake covered in colourful sprinkles — pure celebration.",
  },
  {
    id: "GT4450", name: "Pink Drip Celebration Cake", slug: "pink-drip-celebration-cake",
    image: "https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=800&q=80"],
    categories: ["birthday", "gen-z", "designer"], flavor: "Red Velvet", weight: "1 Kg",
    price: 1599, mrp: 1799, rating: 4.9, reviews: 18, delivery: "Today", bestseller: true,
    description: "Trendy pink drip cake with gold accents — the perfect Instagram-worthy centrepiece.",
  },
  {
    id: "GT4440", name: "Grand Rose Wedding Tier", slug: "grand-rose-wedding-tier",
    image: "https://images.unsplash.com/photo-1604702433171-33756f3f3825?w=600&q=80",
    gallery: ["https://images.unsplash.com/photo-1604702433171-33756f3f3825?w=800&q=80"],
    categories: ["wedding"], flavor: "Vanilla", weight: "2 Kg",
    price: 6499, mrp: 6999, rating: 5.0, reviews: 5, delivery: "Tomorrow", bestseller: false,
    description: "Elegant two-tier wedding cake wrapped in sugar roses and pearl detailing.",
  },
];

// Treat each cake's base value as MRP, then offer a 10% discount as the selling price
PRODUCTS.forEach((p) => {
  p.mrp = p.price;
  p.price = Math.round((p.price * 0.9) / 10) * 10; // 10% off, rounded to nearest 10
});

export const TESTIMONIALS = [
  { id: 1, name: "Ananya Sharma", city: "Noida", rating: 5, text: "The cake was absolutely stunning and tasted even better! Delivered right on time for my mom's birthday.", avatar: "A" },
  { id: 2, name: "Rohit Verma", city: "Greater Noida", rating: 5, text: "Ordered the chocolate truffle cake and it was pure heaven. Globaltreats never disappoints!", avatar: "R" },
  { id: 3, name: "Priya Nair", city: "Noida", rating: 5, text: "Beautiful vintage cake for our anniversary. The detailing was exactly like the picture. Highly recommend!", avatar: "P" },
  { id: 4, name: "Karan Mehta", city: "Delhi NCR", rating: 4, text: "Great designer cake for my son's first birthday. Fresh, moist and beautifully decorated.", avatar: "K" },
];

export const OFFERS = [
  "Free delivery on orders above ₹999",
  "Now delivering across Noida, Greater Noida & Indirapuram (Ghaziabad)",
  "100% eggless options available on every cake",
  "Freshly baked & hand-decorated — Cake Creation By Swati",
];

// Serviceable delivery areas — within 20 km of Sector 78, Noida
export const SERVICE_AREAS = ["Noida", "Greater Noida", "Indirapuram (Ghaziabad)"];
export const DELIVERY_NOTE = "We currently deliver within 20 km of Sector 78, Noida — covering Noida, Greater Noida & Indirapuram (Ghaziabad).";

// Serviceable pincodes within ~20 km of Sector 78, Noida. Editable list.
export const SERVICEABLE_PINCODES = new Set([
  // Noida
  "201301", "201303", "201304", "201305", "201306", "201307", "201308",
  "201309", "201310", "201311", "201312", "201313", "201314", "201318",
  // Greater Noida & Greater Noida West
  "201009", "201016", "203207",
  // Indirapuram (Ghaziabad) & nearby
  "201014", "201010", "201011", "201012",
]);

// Seed orders for admin (frontend mock)
export const MOCK_ORDERS = [
  { id: "ORD-1001", customer: "Ananya Sharma", items: 2, total: 3598, status: "Delivered", date: "2025-07-01" },
  { id: "ORD-1002", customer: "Rohit Verma", items: 1, total: 2599, status: "Baking", date: "2025-07-03" },
  { id: "ORD-1003", customer: "Priya Nair", items: 3, total: 5197, status: "Out for delivery", date: "2025-07-04" },
];
